import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Service extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get image() {
    return get(this, '_obrazek.value[0].url', '');
  }

  get name() {
    return get(this, '_nazwa.value', '');
  }

  get description() {
    return get(this, '_opis.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/Service.model.js